/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ListComponent} from '../../../../../admin-shared/crud-components/list/list.component';
import {CrudConfig} from '../../../../../admin-shared/interfaces/crud.config';
import {BASKET_TABLE_LOG} from '../basket-table-log.config';


@Component({
  selector: 'app-basket-table-log-list',
  templateUrl: '../../../../../admin-shared/crud-components/list/list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketTableLogListComponent extends ListComponent<any> implements OnInit {

  config: CrudConfig = {
    uri: '/dam-basket-log',
    columns: BASKET_TABLE_LOG,
    defaultSortColumn: 'id',
    defaultSortDirection: 'desc',
    title: 'Лог удаления DAM элементов'
  };

  ngOnInit() {
    super.setConfig(this.config);
    super.ngOnInit();
  }
}
